import SubscriptionPlanBase from "../entities/SubscriptionPlan";

export default interface SubscriptionPlanDTO extends SubscriptionPlanBase {
  _id: string;
}

export enum SubscriptionPlanType {
  FREE = 0,
  STARTER = 1,
  BASIC = 2,
  PREMIUM = 3,
  ENTERPRISE = 4,
  CUSTOM = 5
}
